module.exports = __webpack_public_path__ + "static/img/header-1.1bf75379.jpg";